<p-dialog [visible]="visible" (visibleChange)="visibleChange.emit($event)" position="bottom-right">
  <ng-template pTemplate="header">
    <button
      pButton
      class="w-max p-0 gap-2 text-xl font-semibold bg-transparent text-gray-700 border-transparent"
      (click)="navigateToDeviceDetails()"
    >
      {{ selectedIntegrationCode }}
      <i class="pi pi-external-link text-blue-400"></i>
    </button>
  </ng-template>

  <div class="flex align-items-center justify-content-between mb-4">
    <p class="font-semibold text-gray-500">{{ selectedDeviceSerialNumber }}</p>
    <button
      pButton
      [label]="'common.exportXls' | transloco"
      [disabled]="loadingNodes || childNodes.length === 0"
      icon="pi pi-file-excel"
      class="p-button-secondary md:mr-2"
      (click)="exportCommunicationsToExcel()"
    ></button>
  </div>

  <p-table
    [(first)]="first"
    [(rows)]="rows"
    [value]="childNodes"
    [totalRecords]="totalNodes"
    [sortOrder]="-1"
    [autoLayout]="true"
    [paginator]="true"
    styleClass="p-datatable-striped"
    breakpoint="1600px"
    sortField="dateLastValueReported"
    responsiveLayout="stack"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="serialNumber">
          {{ 'attribute.serialNumber' | transloco }}
          <p-sortIcon field="serialNumber"></p-sortIcon>
        </th>
        <th pSortableColumn="integrationIdentifier">
          {{ 'attribute.integrationIdentifier' | transloco }}
          <p-sortIcon field="integrationIdentifier"></p-sortIcon>
        </th>
        <th pSortableColumn="code">
          {{ 'attribute.integrationCode' | transloco }}
          <p-sortIcon field="code"></p-sortIcon>
        </th>
        <th pSortableColumn="lastCommunicationTimestamp">
          {{ 'nettopo.lastCommunicationDate' | transloco }}
          <p-sortIcon field="lastCommunicationTimestamp"></p-sortIcon>
        </th>
        <th pSortableColumn="totalCommunications">
          {{ 'nettopo.totalCommunications' | transloco }}
          <p-sortIcon field="totalCommunications"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-node>
      <tr *ngIf="!loadingNodes" class="fadein">
        <td>
          <span class="p-column-title bold">{{ 'attribute.serialNumber' | transloco }}</span>
          <button
            class="w-full cursor-pointer p-0 gap-2 text-lg font-semibold bg-transparent text-gray-700 border-transparent flex justify-content-between"
            (click)="navigateToDeviceDetails(node.uuid)"
          >
            {{ node.serialNumber }}
          </button>
        </td>
        <td>
          <span class="p-column-title bold">{{ 'attribute.integrationIdentifier' | transloco }}</span>
          <p class="text-right md:text-left">{{ node.integrationIdentifier }}</p>
        </td>
        <td class="devices-table-code-td">
          <span class="p-column-title bold">{{ 'attribute.integrationCode' | transloco }}</span>
          <p class="text-right md:text-left">{{ node.code }}</p>
        </td>
        <td>
          <span class="p-column-title bold">{{ 'nettopo.lastCommunicationDate' | transloco }}</span>
          <p class="text-right md:text-left">{{ node.lastCommunicationTimestamp }}</p>
        </td>
        <td>
          <span class="p-column-title bold">{{ 'nettopo.totalCommunications' | transloco }}</span>
          <p class="text-right md:text-left">{{ node.totalCommunications }}</p>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="summary">
      <div class="flex align-items-center justify-content-between" *ngIf="totalNodes == 0">
        {{ 'pagination.empty' | transloco }}
      </div>
      <div class="flex align-items-center justify-content-between" *ngIf="totalNodes > 0">
        {{ 'pagination.showing' | transloco }} {{ first + 1 }}
        {{ 'pagination.to' | transloco }} {{ (first + rows) >= totalNodes ? totalNodes : (first + rows) }}
        {{ 'pagination.of' | transloco }} {{ totalNodes }}
        {{ (totalNodes > 1 ? 'pagination.entries' : 'pagination.entry') | transloco }}
      </div>
    </ng-template>
  </p-table>
</p-dialog>
